import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { EventTypes } from '../../shared/EventTypes';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { AutenticationEventType } from '../autentication.event.type';
import { AutenticationService } from '../autentication.service';
import { Auth } from '../Auth';
import { AuthMessage } from '../models/auth-message';

@Component({
	selector: 'app-define-subscribe-with-steps',
	templateUrl: './define-subscribe-with-steps.component.html',
	styleUrls: ['./define-subscribe-with-steps.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class DefineSubscribeWithStepsComponent implements OnInit, OnDestroy {

	public form: FormGroup;
	public canSend = false;
	public loading = false;
	public active = false;
	public passDone = false;
	public passError = false;
	public passConfirmDone = false;
	public passConfirmError = false;
	public inputToKeypadSendValue: any;
	public step = 1;
	public title: string;

	constructor(private authService: AutenticationService , private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.initForm();
		this.addListener();
		this.setTitleAndLabelButton();
		this.setInputTarget();
	}

	ngOnDestroy() {
		this.removeListener();
	}

	onSend() {
		this.validatePass();
		this.validateConfirmPass();

		if (this.form.valid && !this.loading && (this.form.controls.pass.value === this.form.controls.confirmPass.value)) {
			this.loading = true;
			this.authService.createSubscribe(this.form.controls.pass.value, Auth.cpf).subscribe( () => {

				this.hide();

				const message = new AuthMessage();
				message.buttonTitle = 'Acessar';
				message.delay = .2;
				message.eventToDispatch = AutenticationEventType.LOGIN.LOGIN;
				message.eventData = null;
				message.delayToDispatchEvent = 0;
				message.hasButton = true;
				message.buttonTitle = 'Acessar',
				message.title = 'Sua senha foi definida com sucesso!';
				message.text = 'A partir de agora, esta será a sua senha para acessar a sua conta.';
				message.withPreload = true;

				AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, message);
			}, error => {
					this.loading = false;

					if (error.status === 422 && error.error.Tipo === 'CodigoSMSInvalido') {
						AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'O código SMS que você recebeu já expirou. Por segurança, você deve reiniciar o processo de definição de senhas.' });
						setTimeout(() => {
							window.location.reload();
						}, 2000);
					} else if (error.error.Mensagem) {
						AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
					}
			});
		}

	}

	show() {
		this.active = true;
		this.inputToKeypadSendValue = this.form.controls.pass;

		TweenMax.delayedCall(.1, () => {
			TweenMax.to('[data-component="define-subscribe-with-steps"]', .8, { delay: .5, left: 0, ease: Quint.easeOut});
		});
	}

	hide() {
		TweenMax.to('[data-component="define-subscribe-with-steps"]', .8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.loading = false;
			this.active = false;
			this.form.controls.pass.reset();
			this.form.controls.confirmPass.reset();
		}});
	}

	public setInputValueFromKeyPad(val: Array<number>) {

		if (this.inputToKeypadSendValue.value.length < 6) {
			this.inputToKeypadSendValue.setValue(this.inputToKeypadSendValue.value.toString() + val[0].toString());
		}

		this.inputToKeypadSendValue.updateValueAndValidity();

		this.canSend = (this.form.valid && (this.form.controls.pass.value === this.form.controls.confirmPass.value));

		if (this.inputToKeypadSendValue === this.form.controls.pass) {
			this.validatePass();
		} else {
			this.validateConfirmPass();
		}

	}

	changeToConfirm() {
		$('[data-component="define-subscribe-with-steps"]').find('.confirm-input').focus();
		this.inputToKeypadSendValue = this.form.controls.confirmPass;
		this.validatePass();
	}

	onCorrect() {
		this.inputToKeypadSendValue.setValue('');
	}

	public prev() {
		this.step--;
		this.setTitleAndLabelButton();
		this.setInputTarget();
	}

	public next() {
		this.step++;
		this.setTitleAndLabelButton();
		this.setInputTarget();
	}

	public setInputTarget() {
		switch (this.step) {
			case 1:
				this.inputToKeypadSendValue = this.form.get('pass');
				break;
			case 2:
				this.inputToKeypadSendValue = this.form.get('confirmPass');
				break;
		}
	}

	private initForm() {
		this.form = this.formBuilder.group({
			'pass': ['', Validators.compose([Validators.required, Validators.pattern(new RegExp(/[0-9]{6,6}/))])],
			'confirmPass': ['', Validators.compose([Validators.required, Validators.pattern(new RegExp(/[0-9]{6,6}/))])]
		});
	}

	private addListener() {
		AppEventDispatcher.listen(AutenticationEventType.LOGIN.DEFINE_SUBSCRIBE, () => {
			this.show();
		});
	}

	private removeListener() {
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.DEFINE_SUBSCRIBE);
	}

	private setTitleAndLabelButton() {
		switch (this.step) {
			case 1:
				this.title = 'Passo 1: Defina uma nova senha';
				break;
			case 2:
				this.title = 'Passo 2: Confirmar nova senha';
				break;
		}
	}

	private validatePass() {
		this.passDone = this.form.controls.pass.valid;
		this.passError = !this.form.controls.pass.valid;
	}

	private validateConfirmPass() {
		const valid = (this.form.controls.confirmPass.valid && (this.form.controls.pass.value === this.form.controls.confirmPass.value));

		this.passConfirmDone = valid;
		this.passConfirmError = !valid;
	}
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/define-subscribe-with-steps/define-subscribe-with-steps.component.ts